import React from 'react'
import { useDispatch ,useSelector} from 'react-redux';
import { toggleCart } from '../store/slices/cartSlice';
import {toggleFavorite} from '../store/slices/favoriteSlice';

export default function Header() {
    const {FavoriteItems}=useSelector((state)=>state.favorite);

    const {cartItems}=useSelector((state)=>state.cart);

    const dispatch=useDispatch();

    const handleOpenCart=(open)=>{
        dispatch(toggleCart(open));
    };

    const handleOpenFavorite=(open)=>{
        dispatch(toggleFavorite(open));
    };

    const Favorite=FavoriteItems.length;

    const cartQuantity=cartItems.length;
    
  return (
    <div>
      <header id="header">
                <div className="container">
                    <div className="navbar">
                        <h4>E-Commerce</h4>
                        <div className="nav_menu">
                            <div
                                title="Favorite"
                                className="fav_icon"
                                onClick={()=>handleOpenFavorite(true)} >
                                <img src="/images/fav.jpg" alt="favorite-icon" />
                                <span className="badge">{Favorite}</span>
                            </div>
                           
                            <div
                                title="Cart"
                                className="cart_icon"
                                onClick={()=>handleOpenCart(true)}
                            
                            >
                                <img src="/images/bag-icon.svg" alt="bag-icon" />
                                <span className="badge">{cartQuantity}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
    </div>
  )
}
